const airlineRetailingTechniqueBlacklist = ['FR'];

export default airlineRetailingTechniqueBlacklist;
